<div class="flex flex-col gap-2 max-w-[21rem]">
  <span class="!font-normal">{{fromDateText}} {{startDate}} {{toDateText}} {{endDate}}</span>
  @if (isShowHeader) {
    <h2 class="m-0 text-base font-normal" [innerHTML]="headerText"></h2>
  }
  @if (isPreview && !isShowHeader) {
    <h2 class="m-0 text-base font-normal">{{effectText}} {{dueToText | lowercase}} {{causeText | lowercase}}</h2>
  }
</div>
